import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { IoTDevListStyle } from './IoTDevListStyle';

type Props = {
  onClickUUpdateScreenButton: () => void;
};

const IoTDevListFooter: React.FC<Props> = (props) => {
  const pageStyle = IoTDevListStyle();
  const { t } = useTranslation();
  return (
    <Grid
      container
      justify="flex-start"
      spacing={1}
      direction="row"
      alignItems="center"
      style={{ width: 'calc(100vw - 12px)' }}
    >
      <Grid item xs={2}>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) => props.onClickUUpdateScreenButton()}
        >
          {t('IoTDevListFooter.画面更新', '画面更新')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default IoTDevListFooter;
